import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class NimbusGridService {
  public calculatePageSize(containerHeight: number, gridOffset: number, gridRowHeight: number): number {
    const result: number = Math.floor((containerHeight - gridOffset) / gridRowHeight);
    return Math.max(1, result);
  }

  public alignSkipToPage(position: number, pageSize: number, total: number): number {
    if (!pageSize || pageSize < 1) {
      return 0;
    }
    const lastPageStart: number = Math.max(0, Math.ceil(total / pageSize) - 1) * pageSize;
    const pageStart: number = Math.floor(Math.max(0, position || 0) / pageSize) * pageSize;
    return Math.min(pageStart, lastPageStart);
  }
}
